import { LS_AUTH_SESSION } from "../const/localstorage_names";

export const getAuthSessionId = () => localStorage.getItem(LS_AUTH_SESSION);

export const startAuthSession = () => {
    const sessionId = crypto.randomUUID();
    localStorage.setItem(LS_AUTH_SESSION, sessionId);
    return sessionId;
};

export const ensureAuthSession = () => getAuthSessionId() || startAuthSession();

export const clearAuthSession = () => {
    localStorage.removeItem(LS_AUTH_SESSION);
};
